module.exports = __webpack_public_path__ + "img/lines.833e13e0.svg";